// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================
   ExpensesListing — Premium Revamped Styles
   ===================================================== */

/* ---------- Page wrapper ---------- */
.expenses-page-wrapper {
  position: relative;
  display: flex;
  height: 100vh;
  width: 100%;
  margin-left: auto;
  flex-direction: column;
  overflow: hidden;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  background-color: #f8fafc; /* bg-slate-50 */
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); /* shadow-2xl */
}

/* ---------- Top header panel ---------- */
.expenses-panel-header {
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e2e8f0; /* border-slate-200 */
  background-color: #ffffff;
  padding: 20px 32px; /* px-8 py-5 */
}

.expenses-panel-title-new {
  font-size: 24px; /* text-2xl */
  font-weight: 700; /* font-bold */
  letter-spacing: -0.025em; /* tracking-tight */
  color: #0f172a; /* text-slate-900 */
  margin: 0;
}

.expenses-panel-header-right-new {
  display: flex;
  align-items: center;
  gap: 16px; /* gap-4 */
}

/* Search input wrapper */
.expenses-search-wrapper {
  position: relative;
  width: 256px; /* w-64 */
  flex-shrink: 0;
}

.expenses-search-icon {
  position: absolute;
  left: 12px; /* left-3 */
  top: 50%;
  transform: translateY(-50%);
  width: 16px; /* h-4 w-4 */
  height: 16px;
  color: #94a3b8; /* text-slate-400 */
  pointer-events: none;
}

.expenses-search-input {
  display: flex;
  height: 38px; /* h-9 */
  width: 100%;
  border-radius: 14px; /* rounded-md */
  border: 1px solid transparent;
  padding: 4px 12px 4px 36px; /* pl-9 */
  font-size: 14px; /* text-sm */
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */
  background-color: #f1f5f9; /* bg-slate-100 */
  color: #0f172a;
  outline: none;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.expenses-search-input::placeholder {
  color: #64748b; /* text-muted-foreground */
}

.expenses-search-input:focus {
  background-color: #ffffff;
  border-color: #cbd5e1;
  box-shadow: 0 0 0 2px rgba(0, 122, 255, 0.15);
}

/* New button styles */
.expenses-header {
  display: inline-flex;
}

.expenses-new-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 14px; /* text-sm */
  font-weight: 500; /* font-medium */
  transition: all 0.2s ease;
  border: 1px solid #007aff;
  border-radius: 20px; /* rounded-xl */
  background-color: #007aff; /* bg-[#007AFF] */
  color: #ffffff;
  padding: 8px 16px; /* px-4 py-2 */
  height: 40px; /* h-10 */
  cursor: pointer;
  box-shadow:
    0 10px 15px -3px rgba(0, 122, 255, 0.2),
    0 4px 6px -4px rgba(0, 122, 255, 0.2);
}

.expenses-new-btn:hover {
  background-color: #006ae6;
  box-shadow: 0 12px 20px -3px rgba(0, 122, 255, 0.3);
}

.expenses-new-btn:active {
  transform: translateY(1px);
}

.expenses-new-btn svg {
  width: 16px; /* h-4 w-4 */
  height: 16px;
  stroke-width: 2.5;
}

/* Close button */
.expenses-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 1px solid transparent;
  width: 36px; /* w-9 */
  height: 36px; /* h-9 */
  border-radius: 9999px; /* rounded-full */
  cursor: pointer;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
}

.expenses-close-btn:hover {
  background-color: #f1f5f9; /* hover:bg-slate-100 */
}

.expenses-close-btn svg {
  width: 20px; /* h-5 w-5 */
  height: 20px;
  color: #64748b; /* text-slate-500 */
}

/* ---------- Expense list area ---------- */
.expenses-list-area {
  position: relative;
  flex: 1;
  background-color: #f8fafc; /* bg-slate-50 */
  padding: 32px; /* p-8 */
  display: flex;
  flex-direction: column;
  gap: 16px; /* space-y-4 */
  overflow-y: auto;
  /* NEW: visible vertical scrollbar */
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #cbd5e1 transparent; /* Firefox: thumb color / track color */
}

/* NEW: visible vertical scrollbar (Chrome / Safari / Edge) */
.expenses-list-area::-webkit-scrollbar {
  width: 8px;
}

.expenses-list-area::-webkit-scrollbar-track {
  background: transparent;
}

.expenses-list-area::-webkit-scrollbar-thumb {
  background-color: #cbd5e1; /* slate-300 */
  border-radius: 20px;
}

.expenses-list-area::-webkit-scrollbar-thumb:hover {
  background-color: #94a3b8; /* slate-400 */
}

/* ---------- Single expense card ---------- */
.expense-card {
  display: flex;
  align-items: center;
  gap: 20px; /* gap-5 */
  border-radius: 20px; /* rounded-xl */
  border: 1px solid #e2e8f0; /* border-slate-200 */
  background-color: #ffffff;
  padding: 20px; /* p-5 */
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */
  transition: all 0.2s ease;
  cursor: default;
}

.expense-card:hover {
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -2px rgba(0, 0, 0, 0.1); /* hover:shadow-md */
  border-color: #cbd5e1;
}

/* Date block */
.expense-card-date {
  display: flex;
  width: 72px; /* w-[72px] */
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 20px; /* rounded-[20px] */
  background-color: rgba(248, 250, 252, 0.8); /* bg-slate-50/80 */
  padding: 12px 0; /* py-3 */
}

.expense-card-date-mmdd {
  font-size: 11px; /* text-[11px] */
  font-weight: 700; /* font-bold */
  letter-spacing: 0.05em; /* tracking-wider */
  color: #94a3b8; /* text-slate-400 */
  line-height: 1;
}

.expense-card-date-time {
  margin-top: 4px; /* mt-1 */
  font-size: 19px; /* text-[19px] */
  font-weight: 900; /* font-black */
  letter-spacing: -0.025em; /* tracking-tight */
  color: #020617; /* text-slate-950 */
  line-height: 1;
}

.expense-card-date-ampm {
  margin-top: 4px; /* mt-1 */
  font-size: 15px; /* text-[15px] */
  font-weight: 900; /* font-black */
  color: #020617; /* text-slate-950 */
  line-height: 1;
}

/* Main card content */
.expense-card-content {
  flex: 1;
  min-width: 0;
}

.expense-card-top-row {
  display: flex;
  align-items: center;
  gap: 12px; /* gap-3 */
  margin-bottom: 4px; /* mb-1 */
}

.expense-card-title {
  font-size: 18px; /* text-lg */
  font-weight: 700; /* font-bold */
  color: #0f172a; /* text-slate-900 */
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Category badge */
.expense-card-badge {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  border-radius: 20px; /* rounded-md */
  padding: 2px 10px; /* px-2.5 py-0.5 */
  font-size: 12px; /* text-xs */
  font-weight: 400; /* font-normal */
  color: #64748b; /* text-slate-500 */
  border: 1px solid #64748b; /* badge-outline border-slate-200 */
  background-color: #ffffff;
}

/* Reason description */
.expense-card-reason {
  font-size: 14px; /* text-sm */
  color: #64748b; /* text-slate-500 */
  margin: 0 0 8px 0; /* mb-2 */
  line-height: 1.4;
}

/* Meta info */
.expense-card-meta {
  display: flex;
  align-items: center;
  gap: 16px; /* gap-4 */
  flex-wrap: wrap;
}

.expense-card-meta-item {
  display: flex;
  align-items: center;
  gap: 6px; /* gap-1.5 */
  font-size: 14px; /* text-sm */
  color: #64748b; /* text-slate-500 */
}

.expense-card-meta-item svg {
  width: 14px; /* h-3.5 w-3.5 */
  height: 14px;
  color: #64748b;
}

.expense-card-meta-approved {
  color: #059669; /* text-emerald-600 */
  font-weight: 500;
}

.expense-card-meta-not-approved {
  color: #64748b; /* text-emerald-600 */
  font-weight: 500;
}

.expense-card-meta-approved svg {
  color: #059669;
}

.expense-card-meta-not-approved svg {
  color: #64748b;
}

/* Right side amount, status, edit actions */
.expense-card-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px; /* gap-2 */
  flex-shrink: 0;
}

.expense-card-amount {
  font-size: 20px; /* text-xl */
  font-weight: 700; /* font-bold */
  color: #0f172a; /* text-slate-900 */
  line-height: 1;
}

/* Status Badge */
.expense-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px; /* gap-1.5 */
  white-space: nowrap;
  border-radius: 20px; /* rounded-md */
  padding: 2px 10px; /* px-2.5 py-0.5 */
  font-size: 12px; /* text-xs */
  font-weight: 500; /* font-medium */
  border: 1px solid transparent;
}

.expense-status-badge svg {
  width: 16px; /* h-4 w-4 */
  height: 16px;
}

.expense-status-approved {
  background-color: #d1fae5; /* bg-emerald-100 */
  color: #065f46; /* text-emerald-700 */
  border-color: #a7f3d0; /* border-emerald-200 */
}

.expense-status-pending {
  background-color: #fef3c7; /* bg-amber-100 */
  color: #92400e; /* text-amber-700 */
  border-color: #fde68a; /* border-amber-200 */
}

.expense-status-rejected {
  background-color: #fee2e2; /* bg-red-100 */
  color: #991b1b; /* text-red-700 */
  border-color: #fecdd3; /* border-red-200 */
}

/* Action Edit Button */
.expense-card-edit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 1px solid transparent;
  padding: 4px;
  border-radius: 6px;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 2px;
}

.expense-card-edit-btn:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

.expense-card-edit-btn svg {
  width: 16px;
  height: 16px;
}

/* ---------- Empty / loading states ---------- */
.expenses-empty-state {
  text-align: center;
  padding: 60px 24px;
  color: #71717a;
  width: 100%;
  margin: auto;
}

.expenses-empty-state svg {
  width: 40px;
  height: 40px;
  color: #d4d4d8;
  margin: 0 auto 12px;
  display: block;
}

.expenses-empty-state p {
  font-size: 14px;
  margin: 0;
}

/* ---------- Pagination row ---------- */
.expenses-pagination-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 32px 24px;
  background-color: #ffffff;
  border-top: 1px solid #e2e8f0;
}

.expenses-page-btn {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #3f3f46;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
}

.expenses-page-btn:hover:not(:disabled) {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #0f172a;
}

.expenses-page-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.expenses-page-btn svg {
  width: 14px;
  height: 14px;
}

.expenses-page-info {
  font-size: 13px;
  color: #64748b;
  padding: 0 8px;
}

/* =====================================================
   AddExpenseModal — Premium Modal Styles
   ===================================================== */

.expense-modal-inner-container {
  padding: 28px 24px 24px 24px;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

@media (min-width: 640px) {
  .expense-modal-inner-container {
    padding: 32px 40px 40px 40px;
  }
}

.expense-modal-title {
  font-size: 28px; /* text-[2rem] fallback */
  font-weight: 600; /* font-semibold */
  letter-spacing: -0.025em; /* tracking-tight */
  color: #0f172a; /* text-slate-900 */
  margin: 0 0 24px 0; /* mb-6 */
  text-align: left;
}

@media (min-width: 640px) {
  .expense-modal-title {
    font-size: 32px;
  }
}

.expense-modal-card-container {
  border-radius: 16px; /* rounded-2xl */
  border: 1px solid #e0f2fe; /* border-sky-100 */
  background-color: #ffffff;
  padding: 20px 16px; /* px-4 py-5 */
  box-shadow: 0 8px 24px rgba(14, 165, 233, 0.06);
  flex: 1;
  overflow-y: auto;
}

@media (min-width: 640px) {
  .expense-modal-card-container {
    padding: 24px; /* sm:px-6 sm:py-6 */
  }
}

.expense-modal-grid {
  display: flex;
  flex-direction: column;
  gap: 5px; /* gap-5 */
}

.expense-modal-row-2col {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

@media (min-width: 640px) {
  .expense-modal-row-2col {
    grid-template-columns: repeat(2, minmax(0, 1fr)); /* grid-cols-2 gap-4 */
    gap: 16px;
  }
}

.expense-modal-field {
  display: flex;
  flex-direction: column;
  gap: 10px; /* space-y-2.5 */
}

.expense-modal-field.mt-5 {
  margin-top: 20px;
}

.expense-modal-field.mt-8 {
  margin-top: 32px;
}

.expense-modal-label {
  font-size: 13px; /* text-[13px] */
  font-weight: 700; /* font-bold */
  color: #334155; /* text-slate-700 */
  text-align: left;
}

.expense-modal-label.font-semibold {
  font-size: 15px; /* text-[15px] */
  font-weight: 600;
  color: #0f172a;
}

.expense-modal-label .text-red-500 {
  color: #ef4444;
}

.expense-modal-input {
  display: flex;
  width: 100%;
  height: 48px; /* h-12 */
  border-radius: 20px; /* rounded-xl */
  border: 1px solid #cbd5e1; /* border-slate-200 */
  background-color: transparent;
  padding: 4px 16px;
  font-size: 15px; /* text-[15px] */
  color: #0f172a;
  outline: none;
  box-shadow: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.expense-modal-input::placeholder {
  color: #94a3b8;
}

.expense-modal-input:focus {
  border-color: #007aff;
  box-shadow: 0 0 0 2px rgba(0, 122, 255, 0.15);
}

/* Currency input wrapper */
.expense-modal-amount-input-wrapper {
  position: relative;
  width: 100%;
}

.expense-modal-amount-currency {
  position: absolute;
  left: 16px; /* pl-4 */
  top: 50%;
  transform: translateY(-50%);
  font-size: 15px;
  font-weight: 500;
  color: #64748b; /* text-slate-500 */
  pointer-events: none;
}

.expense-modal-amount-input {
  padding-left: 32px; /* pl-8 pr-4 */
}

/* Upload button */
.expense-modal-upload-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  transition: all 0.2s ease;
  border: 1px solid #cbd5e1; /* border-slate-200 */
  min-height: 36px;
  padding: 8px 16px;
  height: 56px; /* h-14 */
  width: 100%;
  border-radius: 20px; /* rounded-xl */
  background-color: #f8fafc; /* bg-slate-50 */
  font-size: 18px; /* text-lg */
  font-weight: 600; /* font-semibold */
  color: #0f172a; /* text-slate-900 */
  cursor: pointer;
}

.expense-modal-upload-btn:hover {
  background-color: #f1f5f9; /* hover:bg-slate-100 */
}

.expense-modal-upload-btn svg {
  width: 18px;
  height: 18px;
  color: #0f172a;
}

/* File info box */
.expense-file-upload-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 8px;
  width: 100%;
}

/* Footer / Action buttons */
.expense-modal-footer {
  padding-top: 24px; /* mt-6 */
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}

.expense-modal-submit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  transition: all 0.2s ease;
  border: 1px solid #1f63ea;
  border-radius: 20px; /* rounded-xl */
  background-color: #1f63ea; /* bg-[#1f63ea] */
  color: #ffffff;
  padding: 8px 24px; /* px-6 */
  font-size: 16px; /* text-base */
  font-weight: 600; /* font-semibold */
  height: 48px; /* h-12 */
  cursor: pointer;
  box-shadow: 0 14px 30px rgba(31, 99, 234, 0.22);
}

.expense-modal-submit-btn:hover:not(:disabled) {
  background-color: #155eef; /* hover:bg-[#155EEF] */
}

.expense-modal-submit-btn:disabled {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
  color: #94a3b8;
  cursor: not-allowed;
  box-shadow: none;
}

.expense-modal-submit-btn svg {
  width: 18px;
  height: 18px;
}

/* Absolute Close button */
.expense-modal-close-btn-absolute {
  position: absolute;
  right: 16px; /* right-4 */
  top: 16px; /* top-4 */
  width: 40px; /* w-10 */
  height: 40px; /* h-10 */
  border-radius: 9999px; /* rounded-full */
  border: 1px solid #cbd5e1; /* border-slate-200 */
  background-color: #ffffff;
  color: #64748b; /* text-slate-500 */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */
  transition: all 0.2s ease;
  z-index: 10;
}

.expense-modal-close-btn-absolute:hover {
  background-color: #f8fafc; /* hover:bg-slate-50 */
  color: #0f172a; /* hover:text-slate-900 */
}

.expense-modal-close-btn-absolute svg {
  width: 20px;
  height: 20px;
}

/* Select override styles */
.expense-modal-select > div {
  min-height: 48px !important;
  border-radius: 20px !important;
  border-color: #cbd5e1 !important;
  box-shadow: none !important;
}

.expense-modal-select > div:hover {
  border-color: #94a3b8 !important;
}

/* ---------- Modal scrollbar (visible vertical scrollbar) ---------- */
.expense-modal-scroll-box {
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #cbd5e1 transparent; /* Firefox: thumb color / track color */
}

.expense-modal-scroll-box::-webkit-scrollbar {
  width: 8px; /* Chrome / Safari / Edge */
}

.expense-modal-scroll-box::-webkit-scrollbar-track {
  background: transparent;
}

.expense-modal-scroll-box::-webkit-scrollbar-thumb {
  background-color: #cbd5e1; /* slate-300 */
  border-radius: 20px;
}

.expense-modal-scroll-box::-webkit-scrollbar-thumb:hover {
  background-color: #94a3b8; /* slate-400 */
}
.expense-card {
  position: relative;
  /* overflow: hidden;  */
}

/* Loader overlay */
.expense-card-loader {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 8px;

  /* ✨ animation */
  opacity: 0;
  transform: scale(0.98);
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}

/* Active state */
.expense-card-loader.active {
  opacity: 1;
  transform: scale(1);
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/expenses/expenseListing.css"],"names":[],"mappings":"AAAA;;0DAE0D;;AAE1D,uCAAuC;AACvC;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,+CAA+C;EAC/C,yBAAyB,EAAE,gBAAgB;EAC3C,iDAAiD,EAAE,eAAe;AACpE;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC,EAAE,qBAAqB;EACvD,yBAAyB;EACzB,kBAAkB,EAAE,cAAc;AACpC;;AAEA;EACE,eAAe,EAAE,aAAa;EAC9B,gBAAgB,EAAE,cAAc;EAChC,wBAAwB,EAAE,mBAAmB;EAC7C,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,UAAU;AACvB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,YAAY,EAAE,SAAS;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,WAAW;EACvB,QAAQ;EACR,2BAA2B;EAC3B,WAAW,EAAE,YAAY;EACzB,YAAY;EACZ,cAAc,EAAE,mBAAmB;EACnC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY,EAAE,QAAQ;EACtB,WAAW;EACX,mBAAmB,EAAE,eAAe;EACpC,6BAA6B;EAC7B,0BAA0B,EAAE,SAAS;EACrC,eAAe,EAAE,YAAY;EAC7B,2CAA2C,EAAE,cAAc;EAC3D,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc;EACd,aAAa;EACb;;;wBAGsB;AACxB;;AAEA;EACE,cAAc,EAAE,0BAA0B;AAC5C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,gBAAgB;EAClC,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB,EAAE,eAAe;EACpC,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc;EACd,iBAAiB,EAAE,cAAc;EACjC,YAAY,EAAE,SAAS;EACvB,eAAe;EACf;;yCAEuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW,EAAE,QAAQ;EACrB,YAAY,EAAE,QAAQ;EACtB,qBAAqB,EAAE,iBAAiB;EACxC,eAAe;EACf,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,YAAY;EACZ,cAAc,EAAE,mBAAmB;AACrC;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,OAAO;EACP,yBAAyB,EAAE,gBAAgB;EAC3C,aAAa,EAAE,QAAQ;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,cAAc;EACzB,gBAAgB;EAChB,oCAAoC;EACpC,qBAAqB,EAAE,YAAY;EACnC,oCAAoC,EAAE,uCAAuC;AAC/E;;AAEA,6DAA6D;AAC7D;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB,EAAE,cAAc;EACzC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,cAAc;AAC3C;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,UAAU;EACrB,mBAAmB,EAAE,eAAe;EACpC,yBAAyB,EAAE,qBAAqB;EAChD,yBAAyB;EACzB,aAAa,EAAE,QAAQ;EACvB,2CAA2C,EAAE,cAAc;EAC3D,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE;;qCAEmC,EAAE,oBAAoB;EACzD,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,WAAW,EAAE,aAAa;EAC1B,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB,EAAE,mBAAmB;EACxC,0CAA0C,EAAE,mBAAmB;EAC/D,eAAe,EAAE,SAAS;AAC5B;;AAEA;EACE,eAAe,EAAE,gBAAgB;EACjC,gBAAgB,EAAE,cAAc;EAChC,sBAAsB,EAAE,mBAAmB;EAC3C,cAAc,EAAE,mBAAmB;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,eAAe,EAAE,gBAAgB;EACjC,gBAAgB,EAAE,eAAe;EACjC,wBAAwB,EAAE,mBAAmB;EAC7C,cAAc,EAAE,mBAAmB;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,eAAe,EAAE,gBAAgB;EACjC,gBAAgB,EAAE,eAAe;EACjC,cAAc,EAAE,mBAAmB;EACnC,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,UAAU;EACrB,kBAAkB,EAAE,SAAS;AAC/B;;AAEA;EACE,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,cAAc;EAChC,cAAc,EAAE,mBAAmB;EACnC,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,EAAE,eAAe;EACpC,iBAAiB,EAAE,kBAAkB;EACrC,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,gBAAgB;EAClC,cAAc,EAAE,mBAAmB;EACnC,yBAAyB,EAAE,mCAAmC;EAC9D,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,eAAe,EAAE,YAAY;EAC7B,cAAc,EAAE,mBAAmB;EACnC,iBAAiB,EAAE,SAAS;EAC5B,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,UAAU;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,YAAY;EACtB,eAAe,EAAE,YAAY;EAC7B,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,WAAW,EAAE,gBAAgB;EAC7B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc,EAAE,qBAAqB;EACrC,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,qBAAqB;EACrC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ,EAAE,UAAU;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,cAAc;EAChC,cAAc,EAAE,mBAAmB;EACnC,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ,EAAE,YAAY;EACtB,mBAAmB;EACnB,mBAAmB,EAAE,eAAe;EACpC,iBAAiB,EAAE,kBAAkB;EACrC,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,gBAAgB;EAClC,6BAA6B;AAC/B;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,cAAc,EAAE,qBAAqB;EACrC,qBAAqB,EAAE,uBAAuB;AAChD;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc,EAAE,mBAAmB;EACnC,qBAAqB,EAAE,qBAAqB;AAC9C;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,cAAc,EAAE,iBAAiB;EACjC,qBAAqB,EAAE,mBAAmB;AAC5C;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;;0DAE0D;;AAE1D;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,eAAe,EAAE,yBAAyB;EAC1C,gBAAgB,EAAE,kBAAkB;EACpC,wBAAwB,EAAE,mBAAmB;EAC7C,cAAc,EAAE,mBAAmB;EACnC,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB,EAAE,gBAAgB;EACrC,yBAAyB,EAAE,mBAAmB;EAC9C,yBAAyB;EACzB,kBAAkB,EAAE,cAAc;EAClC,+CAA+C;EAC/C,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa,EAAE,oBAAoB;EACrC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAE,UAAU;AACtB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,gDAAgD,EAAE,sBAAsB;IACxE,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,gBAAgB;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe,EAAE,gBAAgB;EACjC,gBAAgB,EAAE,cAAc;EAChC,cAAc,EAAE,mBAAmB;EACnC,gBAAgB;AAClB;;AAEA;EACE,eAAe,EAAE,gBAAgB;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY,EAAE,SAAS;EACvB,mBAAmB,EAAE,eAAe;EACpC,yBAAyB,EAAE,qBAAqB;EAChD,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe,EAAE,gBAAgB;EACjC,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB;;wBAEsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,SAAS;EACrB,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;EACnC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB,EAAE,cAAc;AACpC;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB,EAAE,qBAAqB;EAChD,gBAAgB;EAChB,iBAAiB;EACjB,YAAY,EAAE,SAAS;EACvB,WAAW;EACX,mBAAmB,EAAE,eAAe;EACpC,yBAAyB,EAAE,gBAAgB;EAC3C,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,kBAAkB;EACpC,cAAc,EAAE,mBAAmB;EACnC,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB,EAAE,SAAS;EAC5B,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB,EAAE,eAAe;EACpC,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc;EACd,iBAAiB,EAAE,SAAS;EAC5B,eAAe,EAAE,cAAc;EAC/B,gBAAgB,EAAE,kBAAkB;EACpC,YAAY,EAAE,SAAS;EACvB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,WAAW,EAAE,YAAY;EACzB,SAAS,EAAE,UAAU;EACrB,WAAW,EAAE,SAAS;EACtB,YAAY,EAAE,SAAS;EACvB,qBAAqB,EAAE,iBAAiB;EACxC,yBAAyB,EAAE,qBAAqB;EAChD,yBAAyB;EACzB,cAAc,EAAE,mBAAmB;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2CAA2C,EAAE,cAAc;EAC3D,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;EACjD,cAAc,EAAE,yBAAyB;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,uEAAuE;AACvE;EACE,qBAAqB,EAAE,YAAY;EACnC,oCAAoC,EAAE,uCAAuC;AAC/E;;AAEA;EACE,UAAU,EAAE,2BAA2B;AACzC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB,EAAE,cAAc;EACzC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,cAAc;AAC3C;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;;EAElB,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB;;uBAEqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,mBAAmB;AACrB","sourcesContent":["/* =====================================================\n   ExpensesListing — Premium Revamped Styles\n   ===================================================== */\n\n/* ---------- Page wrapper ---------- */\n.expenses-page-wrapper {\n  position: relative;\n  display: flex;\n  height: 100vh;\n  width: 100%;\n  margin-left: auto;\n  flex-direction: column;\n  overflow: hidden;\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n  background-color: #f8fafc; /* bg-slate-50 */\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); /* shadow-2xl */\n}\n\n/* ---------- Top header panel ---------- */\n.expenses-panel-header {\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #e2e8f0; /* border-slate-200 */\n  background-color: #ffffff;\n  padding: 20px 32px; /* px-8 py-5 */\n}\n\n.expenses-panel-title-new {\n  font-size: 24px; /* text-2xl */\n  font-weight: 700; /* font-bold */\n  letter-spacing: -0.025em; /* tracking-tight */\n  color: #0f172a; /* text-slate-900 */\n  margin: 0;\n}\n\n.expenses-panel-header-right-new {\n  display: flex;\n  align-items: center;\n  gap: 16px; /* gap-4 */\n}\n\n/* Search input wrapper */\n.expenses-search-wrapper {\n  position: relative;\n  width: 256px; /* w-64 */\n  flex-shrink: 0;\n}\n\n.expenses-search-icon {\n  position: absolute;\n  left: 12px; /* left-3 */\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px; /* h-4 w-4 */\n  height: 16px;\n  color: #94a3b8; /* text-slate-400 */\n  pointer-events: none;\n}\n\n.expenses-search-input {\n  display: flex;\n  height: 38px; /* h-9 */\n  width: 100%;\n  border-radius: 14px; /* rounded-md */\n  border: 1px solid transparent;\n  padding: 4px 12px 4px 36px; /* pl-9 */\n  font-size: 14px; /* text-sm */\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */\n  background-color: #f1f5f9; /* bg-slate-100 */\n  color: #0f172a;\n  outline: none;\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.expenses-search-input::placeholder {\n  color: #64748b; /* text-muted-foreground */\n}\n\n.expenses-search-input:focus {\n  background-color: #ffffff;\n  border-color: #cbd5e1;\n  box-shadow: 0 0 0 2px rgba(0, 122, 255, 0.15);\n}\n\n/* New button styles */\n.expenses-header {\n  display: inline-flex;\n}\n\n.expenses-new-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 14px; /* text-sm */\n  font-weight: 500; /* font-medium */\n  transition: all 0.2s ease;\n  border: 1px solid #007aff;\n  border-radius: 20px; /* rounded-xl */\n  background-color: #007aff; /* bg-[#007AFF] */\n  color: #ffffff;\n  padding: 8px 16px; /* px-4 py-2 */\n  height: 40px; /* h-10 */\n  cursor: pointer;\n  box-shadow:\n    0 10px 15px -3px rgba(0, 122, 255, 0.2),\n    0 4px 6px -4px rgba(0, 122, 255, 0.2);\n}\n\n.expenses-new-btn:hover {\n  background-color: #006ae6;\n  box-shadow: 0 12px 20px -3px rgba(0, 122, 255, 0.3);\n}\n\n.expenses-new-btn:active {\n  transform: translateY(1px);\n}\n\n.expenses-new-btn svg {\n  width: 16px; /* h-4 w-4 */\n  height: 16px;\n  stroke-width: 2.5;\n}\n\n/* Close button */\n.expenses-close-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: 1px solid transparent;\n  width: 36px; /* w-9 */\n  height: 36px; /* h-9 */\n  border-radius: 9999px; /* rounded-full */\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  flex-shrink: 0;\n}\n\n.expenses-close-btn:hover {\n  background-color: #f1f5f9; /* hover:bg-slate-100 */\n}\n\n.expenses-close-btn svg {\n  width: 20px; /* h-5 w-5 */\n  height: 20px;\n  color: #64748b; /* text-slate-500 */\n}\n\n/* ---------- Expense list area ---------- */\n.expenses-list-area {\n  position: relative;\n  flex: 1;\n  background-color: #f8fafc; /* bg-slate-50 */\n  padding: 32px; /* p-8 */\n  display: flex;\n  flex-direction: column;\n  gap: 16px; /* space-y-4 */\n  overflow-y: auto;\n  /* NEW: visible vertical scrollbar */\n  scrollbar-width: thin; /* Firefox */\n  scrollbar-color: #cbd5e1 transparent; /* Firefox: thumb color / track color */\n}\n\n/* NEW: visible vertical scrollbar (Chrome / Safari / Edge) */\n.expenses-list-area::-webkit-scrollbar {\n  width: 8px;\n}\n\n.expenses-list-area::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.expenses-list-area::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1; /* slate-300 */\n  border-radius: 20px;\n}\n\n.expenses-list-area::-webkit-scrollbar-thumb:hover {\n  background-color: #94a3b8; /* slate-400 */\n}\n\n/* ---------- Single expense card ---------- */\n.expense-card {\n  display: flex;\n  align-items: center;\n  gap: 20px; /* gap-5 */\n  border-radius: 20px; /* rounded-xl */\n  border: 1px solid #e2e8f0; /* border-slate-200 */\n  background-color: #ffffff;\n  padding: 20px; /* p-5 */\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */\n  transition: all 0.2s ease;\n  cursor: default;\n}\n\n.expense-card:hover {\n  box-shadow:\n    0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -2px rgba(0, 0, 0, 0.1); /* hover:shadow-md */\n  border-color: #cbd5e1;\n}\n\n/* Date block */\n.expense-card-date {\n  display: flex;\n  width: 72px; /* w-[72px] */\n  flex-shrink: 0;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px; /* rounded-[20px] */\n  background-color: rgba(248, 250, 252, 0.8); /* bg-slate-50/80 */\n  padding: 12px 0; /* py-3 */\n}\n\n.expense-card-date-mmdd {\n  font-size: 11px; /* text-[11px] */\n  font-weight: 700; /* font-bold */\n  letter-spacing: 0.05em; /* tracking-wider */\n  color: #94a3b8; /* text-slate-400 */\n  line-height: 1;\n}\n\n.expense-card-date-time {\n  margin-top: 4px; /* mt-1 */\n  font-size: 19px; /* text-[19px] */\n  font-weight: 900; /* font-black */\n  letter-spacing: -0.025em; /* tracking-tight */\n  color: #020617; /* text-slate-950 */\n  line-height: 1;\n}\n\n.expense-card-date-ampm {\n  margin-top: 4px; /* mt-1 */\n  font-size: 15px; /* text-[15px] */\n  font-weight: 900; /* font-black */\n  color: #020617; /* text-slate-950 */\n  line-height: 1;\n}\n\n/* Main card content */\n.expense-card-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.expense-card-top-row {\n  display: flex;\n  align-items: center;\n  gap: 12px; /* gap-3 */\n  margin-bottom: 4px; /* mb-1 */\n}\n\n.expense-card-title {\n  font-size: 18px; /* text-lg */\n  font-weight: 700; /* font-bold */\n  color: #0f172a; /* text-slate-900 */\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Category badge */\n.expense-card-badge {\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n  border-radius: 20px; /* rounded-md */\n  padding: 2px 10px; /* px-2.5 py-0.5 */\n  font-size: 12px; /* text-xs */\n  font-weight: 400; /* font-normal */\n  color: #64748b; /* text-slate-500 */\n  border: 1px solid #64748b; /* badge-outline border-slate-200 */\n  background-color: #ffffff;\n}\n\n/* Reason description */\n.expense-card-reason {\n  font-size: 14px; /* text-sm */\n  color: #64748b; /* text-slate-500 */\n  margin: 0 0 8px 0; /* mb-2 */\n  line-height: 1.4;\n}\n\n/* Meta info */\n.expense-card-meta {\n  display: flex;\n  align-items: center;\n  gap: 16px; /* gap-4 */\n  flex-wrap: wrap;\n}\n\n.expense-card-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 6px; /* gap-1.5 */\n  font-size: 14px; /* text-sm */\n  color: #64748b; /* text-slate-500 */\n}\n\n.expense-card-meta-item svg {\n  width: 14px; /* h-3.5 w-3.5 */\n  height: 14px;\n  color: #64748b;\n}\n\n.expense-card-meta-approved {\n  color: #059669; /* text-emerald-600 */\n  font-weight: 500;\n}\n\n.expense-card-meta-not-approved {\n  color: #64748b; /* text-emerald-600 */\n  font-weight: 500;\n}\n\n.expense-card-meta-approved svg {\n  color: #059669;\n}\n\n.expense-card-meta-not-approved svg {\n  color: #64748b;\n}\n\n/* Right side amount, status, edit actions */\n.expense-card-right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px; /* gap-2 */\n  flex-shrink: 0;\n}\n\n.expense-card-amount {\n  font-size: 20px; /* text-xl */\n  font-weight: 700; /* font-bold */\n  color: #0f172a; /* text-slate-900 */\n  line-height: 1;\n}\n\n/* Status Badge */\n.expense-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px; /* gap-1.5 */\n  white-space: nowrap;\n  border-radius: 20px; /* rounded-md */\n  padding: 2px 10px; /* px-2.5 py-0.5 */\n  font-size: 12px; /* text-xs */\n  font-weight: 500; /* font-medium */\n  border: 1px solid transparent;\n}\n\n.expense-status-badge svg {\n  width: 16px; /* h-4 w-4 */\n  height: 16px;\n}\n\n.expense-status-approved {\n  background-color: #d1fae5; /* bg-emerald-100 */\n  color: #065f46; /* text-emerald-700 */\n  border-color: #a7f3d0; /* border-emerald-200 */\n}\n\n.expense-status-pending {\n  background-color: #fef3c7; /* bg-amber-100 */\n  color: #92400e; /* text-amber-700 */\n  border-color: #fde68a; /* border-amber-200 */\n}\n\n.expense-status-rejected {\n  background-color: #fee2e2; /* bg-red-100 */\n  color: #991b1b; /* text-red-700 */\n  border-color: #fecdd3; /* border-red-200 */\n}\n\n/* Action Edit Button */\n.expense-card-edit-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: 1px solid transparent;\n  padding: 4px;\n  border-radius: 6px;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-top: 2px;\n}\n\n.expense-card-edit-btn:hover {\n  background-color: #f1f5f9;\n  color: #0f172a;\n}\n\n.expense-card-edit-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* ---------- Empty / loading states ---------- */\n.expenses-empty-state {\n  text-align: center;\n  padding: 60px 24px;\n  color: #71717a;\n  width: 100%;\n  margin: auto;\n}\n\n.expenses-empty-state svg {\n  width: 40px;\n  height: 40px;\n  color: #d4d4d8;\n  margin: 0 auto 12px;\n  display: block;\n}\n\n.expenses-empty-state p {\n  font-size: 14px;\n  margin: 0;\n}\n\n/* ---------- Pagination row ---------- */\n.expenses-pagination-row {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 16px 32px 24px;\n  background-color: #ffffff;\n  border-top: 1px solid #e2e8f0;\n}\n\n.expenses-page-btn {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #3f3f46;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.2s ease;\n}\n\n.expenses-page-btn:hover:not(:disabled) {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.expenses-page-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.expenses-page-btn svg {\n  width: 14px;\n  height: 14px;\n}\n\n.expenses-page-info {\n  font-size: 13px;\n  color: #64748b;\n  padding: 0 8px;\n}\n\n/* =====================================================\n   AddExpenseModal — Premium Modal Styles\n   ===================================================== */\n\n.expense-modal-inner-container {\n  padding: 28px 24px 24px 24px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n@media (min-width: 640px) {\n  .expense-modal-inner-container {\n    padding: 32px 40px 40px 40px;\n  }\n}\n\n.expense-modal-title {\n  font-size: 28px; /* text-[2rem] fallback */\n  font-weight: 600; /* font-semibold */\n  letter-spacing: -0.025em; /* tracking-tight */\n  color: #0f172a; /* text-slate-900 */\n  margin: 0 0 24px 0; /* mb-6 */\n  text-align: left;\n}\n\n@media (min-width: 640px) {\n  .expense-modal-title {\n    font-size: 32px;\n  }\n}\n\n.expense-modal-card-container {\n  border-radius: 16px; /* rounded-2xl */\n  border: 1px solid #e0f2fe; /* border-sky-100 */\n  background-color: #ffffff;\n  padding: 20px 16px; /* px-4 py-5 */\n  box-shadow: 0 8px 24px rgba(14, 165, 233, 0.06);\n  flex: 1;\n  overflow-y: auto;\n}\n\n@media (min-width: 640px) {\n  .expense-modal-card-container {\n    padding: 24px; /* sm:px-6 sm:py-6 */\n  }\n}\n\n.expense-modal-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 5px; /* gap-5 */\n}\n\n.expense-modal-row-2col {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n}\n\n@media (min-width: 640px) {\n  .expense-modal-row-2col {\n    grid-template-columns: repeat(2, minmax(0, 1fr)); /* grid-cols-2 gap-4 */\n    gap: 16px;\n  }\n}\n\n.expense-modal-field {\n  display: flex;\n  flex-direction: column;\n  gap: 10px; /* space-y-2.5 */\n}\n\n.expense-modal-field.mt-5 {\n  margin-top: 20px;\n}\n\n.expense-modal-field.mt-8 {\n  margin-top: 32px;\n}\n\n.expense-modal-label {\n  font-size: 13px; /* text-[13px] */\n  font-weight: 700; /* font-bold */\n  color: #334155; /* text-slate-700 */\n  text-align: left;\n}\n\n.expense-modal-label.font-semibold {\n  font-size: 15px; /* text-[15px] */\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.expense-modal-label .text-red-500 {\n  color: #ef4444;\n}\n\n.expense-modal-input {\n  display: flex;\n  width: 100%;\n  height: 48px; /* h-12 */\n  border-radius: 20px; /* rounded-xl */\n  border: 1px solid #cbd5e1; /* border-slate-200 */\n  background-color: transparent;\n  padding: 4px 16px;\n  font-size: 15px; /* text-[15px] */\n  color: #0f172a;\n  outline: none;\n  box-shadow: none;\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.expense-modal-input::placeholder {\n  color: #94a3b8;\n}\n\n.expense-modal-input:focus {\n  border-color: #007aff;\n  box-shadow: 0 0 0 2px rgba(0, 122, 255, 0.15);\n}\n\n/* Currency input wrapper */\n.expense-modal-amount-input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.expense-modal-amount-currency {\n  position: absolute;\n  left: 16px; /* pl-4 */\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 15px;\n  font-weight: 500;\n  color: #64748b; /* text-slate-500 */\n  pointer-events: none;\n}\n\n.expense-modal-amount-input {\n  padding-left: 32px; /* pl-8 pr-4 */\n}\n\n/* Upload button */\n.expense-modal-upload-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n  border: 1px solid #cbd5e1; /* border-slate-200 */\n  min-height: 36px;\n  padding: 8px 16px;\n  height: 56px; /* h-14 */\n  width: 100%;\n  border-radius: 20px; /* rounded-xl */\n  background-color: #f8fafc; /* bg-slate-50 */\n  font-size: 18px; /* text-lg */\n  font-weight: 600; /* font-semibold */\n  color: #0f172a; /* text-slate-900 */\n  cursor: pointer;\n}\n\n.expense-modal-upload-btn:hover {\n  background-color: #f1f5f9; /* hover:bg-slate-100 */\n}\n\n.expense-modal-upload-btn svg {\n  width: 18px;\n  height: 18px;\n  color: #0f172a;\n}\n\n/* File info box */\n.expense-file-upload-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px;\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  width: 100%;\n}\n\n/* Footer / Action buttons */\n.expense-modal-footer {\n  padding-top: 24px; /* mt-6 */\n  display: flex;\n  justify-content: flex-end;\n  flex-shrink: 0;\n}\n\n.expense-modal-submit-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n  border: 1px solid #1f63ea;\n  border-radius: 20px; /* rounded-xl */\n  background-color: #1f63ea; /* bg-[#1f63ea] */\n  color: #ffffff;\n  padding: 8px 24px; /* px-6 */\n  font-size: 16px; /* text-base */\n  font-weight: 600; /* font-semibold */\n  height: 48px; /* h-12 */\n  cursor: pointer;\n  box-shadow: 0 14px 30px rgba(31, 99, 234, 0.22);\n}\n\n.expense-modal-submit-btn:hover:not(:disabled) {\n  background-color: #155eef; /* hover:bg-[#155EEF] */\n}\n\n.expense-modal-submit-btn:disabled {\n  background-color: #f1f5f9;\n  border-color: #cbd5e1;\n  color: #94a3b8;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.expense-modal-submit-btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* Absolute Close button */\n.expense-modal-close-btn-absolute {\n  position: absolute;\n  right: 16px; /* right-4 */\n  top: 16px; /* top-4 */\n  width: 40px; /* w-10 */\n  height: 40px; /* h-10 */\n  border-radius: 9999px; /* rounded-full */\n  border: 1px solid #cbd5e1; /* border-slate-200 */\n  background-color: #ffffff;\n  color: #64748b; /* text-slate-500 */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */\n  transition: all 0.2s ease;\n  z-index: 10;\n}\n\n.expense-modal-close-btn-absolute:hover {\n  background-color: #f8fafc; /* hover:bg-slate-50 */\n  color: #0f172a; /* hover:text-slate-900 */\n}\n\n.expense-modal-close-btn-absolute svg {\n  width: 20px;\n  height: 20px;\n}\n\n/* Select override styles */\n.expense-modal-select > div {\n  min-height: 48px !important;\n  border-radius: 20px !important;\n  border-color: #cbd5e1 !important;\n  box-shadow: none !important;\n}\n\n.expense-modal-select > div:hover {\n  border-color: #94a3b8 !important;\n}\n\n/* ---------- Modal scrollbar (visible vertical scrollbar) ---------- */\n.expense-modal-scroll-box {\n  scrollbar-width: thin; /* Firefox */\n  scrollbar-color: #cbd5e1 transparent; /* Firefox: thumb color / track color */\n}\n\n.expense-modal-scroll-box::-webkit-scrollbar {\n  width: 8px; /* Chrome / Safari / Edge */\n}\n\n.expense-modal-scroll-box::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.expense-modal-scroll-box::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1; /* slate-300 */\n  border-radius: 20px;\n}\n\n.expense-modal-scroll-box::-webkit-scrollbar-thumb:hover {\n  background-color: #94a3b8; /* slate-400 */\n}\n.expense-card {\n  position: relative;\n  /* overflow: hidden;  */\n}\n\n/* Loader overlay */\n.expense-card-loader {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background: rgba(255, 255, 255, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  border-radius: 8px;\n\n  /* ✨ animation */\n  opacity: 0;\n  transform: scale(0.98);\n  transition:\n    opacity 0.3s ease,\n    transform 0.3s ease;\n}\n\n/* Active state */\n.expense-card-loader.active {\n  opacity: 1;\n  transform: scale(1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
